<template>
  <vs-prompt
    :title="'Add table for ' + (section ? section.name : '')"
    @cancel="val = ''"
    @accept="onAccept"
    :active.sync="addNewCampaignPrompt"
    :accept-text="'Save table'"
    :is-valid="validForm"
    class="edit-venue-popup">
    <ul class="leftx flex" v-if="section">
      <li class="mr-8">
        <vs-radio v-model="selectionMode" :vs-name="'radios' + section.id" vs-value="add-new" @change="setMoveTables()" >Add new table</vs-radio>
      </li>
      <li class="mr-2">
        <vs-radio v-model="selectionMode" :vs-name="'radios' + section.id" vs-value="move" @change="setMoveTables()" >Move from other section</vs-radio>
      </li>
    </ul>
    <div v-if="selectionMode == 'add-new'">
      <div>
          <h6 class="mt-6">Table name</h6>
          <p class="mb-1"><small>Give it a name. Example: 'Table 1'</small></p>
          <vs-input class="inputx" placeholder="Table name" v-model="tableName"/>
      </div>

      <div>
          <h6 class="mt-6">Number of seats</h6>
          <p class="mb-1"><small>How many seats?</small></p>
          <vs-input class="inputx" placeholder="Number of seats" type="number" v-model="numSeats"/>
      </div>
    </div>
    <div  v-if="selectionMode == 'move'">
      <p class="mt-2">Select tables</p>
      <div class="mt-4" v-for="tSection of tableSelects" :key="tSection.sectionId">
        <p><b>{{tSection.sectionName}}</b></p>
        <ul class="flex">
          <li>
            <vs-checkbox class="mt-2" v-for="table of tSection.tables" :key="table.table.id" v-model="table.isSelected" :vs-value="true">{{table.table.name}}</vs-checkbox>
          </li>
        </ul>

      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS} from "@/store/modules/marcom/marcom";

export default {
  components: { },
  data() {
    return {
      section: null,
      setup:null,
      tableName:'',
      tableSelects:[],
      numSeats:null,
      addNewCampaignPrompt: false,
      callback:null,
      selectionMode:"add-new",
      sections:[]
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      isLoadingLocations: "marcom/isLoadingLocations",
      activeVenueSetups: "marcom/activeVenueSetups",
    }),
    validForm() {
      if (this.selectionMode == "add-new")
        return this.tableName !== '' && this.numSeats != null;
    }
  },
  methods: {
    show(section, setup, sections) {
      this.section = section;
      this.setup = setup;
      this.addNewCampaignPrompt = true;
      this.sections = sections;
    },
    setMoveTables() {
      if (this.selectionMode == 'move') {
        this.tableSelects = this.sections.filter(s => s.id != this.section.id && s.venueTables.length > 0).map(s => {
          return {
            sectionName: s.name,
            sectionId: s.id,
            section: s,
            tables: s.venueTables.map (t => {
              return {
                table:t,
                isSelected:false
              }
            })
          }
        });
      }
    },
    async onAccept() {
      this.$vs.loading();

      if (this.selectionMode == 'add-new') {

        //Call service
        var tableCommand = {
          name: this.tableName,
          seatCount: this.numSeats,
          venueSetupId: this.setup.id,
          venueSectionId: this.section.id,
          note: ""
        }

        var result = await this.$store.dispatch('marcom/' + VENUE_ACTIONS.AddTable, tableCommand);

        //this.section.venueTables.push(result);

        this.$vs.notify({
          color: "success",
          title: "Table added",
          text: "Your table was added",
        });

        this.setupName = '';

        this.$emit("table-added", this.result);
      }
      else if (this.selectionMode == 'move') {
        var tableMoveCommand = {
          setupId: this.setup.id,
          moveToSection: this.section,
          tableSelects: this.tableSelects.filter(ts => ts.tables.some(t => t.isSelected)).map(ts => {
            return {
              sectionName: ts.sectionName,
              sectionId: ts.sectionId,
              section: ts.section,
              tables: ts.tables.filter(t => t.isSelected)
            }
          })
        };

        try {
          var resultMove = await this.$store.dispatch('marcom/' + VENUE_ACTIONS.MoveTables, tableMoveCommand);

          this.$vs.notify({
            color: "success",
            title: "Tables moved",
            text: "Your tables where moved",
          });

          this.$emit("table-added", this.resultMove);
        }
        catch (err) {
          this.$vs.notify({
            color: "danger",
            title: "Errer",
            text: "Your tables where not moved: " + err ,
          });
        }

      }

      this.$vs.loading.close();

      return result;
    },
  },
};
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.edit-venue-popup.con-vs-dialog .vs-dialog {
  max-width: 1080px !important;
  position: relative;

  .vs-dialog-text {
    padding: 2rem !important;
  }

  .dialog-title {
    padding: 2rem;
  }
}

.vs-dialog {
  position: relative;

  overflow-y: auto;
  overflow-x: clip;
  max-height: 100%;
}

.button-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.color-select {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    position: relative;
    width: 20px;
    height: 20px;
    margin: 10px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    $colors: (
      #cccccc,
      #cea8bc,
      #a9c3c8,
      #bcd611,
      #de9c9b,
      #fbe6a2,
      #aac1f0,
      #b2a7d2,
      #bc4b31,
      #111111
    );
    @for $i from 1 through length($colors) {
      &:nth-child(#{$i}) {
        background-color: nth($colors, $i);
        box-shadow: 0px 8px 12px -6px lighten(nth($colors, $i), 0.9);
      }
    }

    .selected {
      position: absolute;
      display: block;
      border-radius: 50%;
      border: 3px solid black;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
